export const wechatlist = []
export const getWay = {
  role: {
    type: 'role',
    params: {
      role_id: ['50', '51']
    },
    url: '/api/ucenter.user/roleUserList'
  },
  department: {
    type: 'department',
    params: {
      department_id: ['50']
    },

    url: '/api/ucenter.user/departmentUserList'
  }
}
// 审核结果状态是指当前项目的审核流程的结果
export const auditResultStatusList = [
  {
    id: 0,
    title: '待审核'
  },
  {
    id: 1,
    title: '审核中'
  },
  {
    id: 2,
    title: '审核通过'
  },
  {
    id: 3,
    title: '审核驳回'
  },
  {
    id: 13,
    title: '审核撤销'
  }
];

// 审核状态是指审核者单条审核任务的审核结果
export const auditItemStatusList = [
  {
    id: 0,
    title: '待审核'
  },
  {
    id: 1,
    title: '审核通过'
  },
  {
    id: 2,
    title: '审核驳回'
  },
  {
    id: 3,
    title: '审核转交'
  }
];

// 结算状态列表
export const settlementStatusList = [
  {
    id: 0,
    title: '待结算'
  },
  {
    id: 1,
    title: '结算中'
  },
  {
    id: 2,
    title: '已结算'
  }
];
//总控管理　订单状态
export const delayStatusList = [{
  id: '1',
  title: '已举办'
}, {
  id: '2',
  title: '未举办'
}, {
  id: '3',
  title: '待定中'
}, {
  id: '4',
  title: '退单'
}];
// 日期相关
export const pickerDateOptions = {
  shortcuts: [{
    text: '最近一周',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', [start, end]);
    }
  },
  {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit('pick', [start, end]);
    }
  },
  {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      picker.$emit('pick', [start, end]);
    }
  }
  ]
};
